<template>
  <div :style="{ height, width }" id="EchartsGG" ref="docement"></div>
</template>
<script>
import { ref, onMounted } from "vue";
import * as echarts from "echarts";
export default {
  name: "baseBar",
  props: {
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    left1Data: {
      type: Object,
      default: () => {},
    },
  },
  data: function () {
    return {
      echartsData: {
        size: 21,
        list: [
          { dysl: "75", mc: "灌溉水", sysl: "100" },
          { dysl: "83.3", mc: "用肥", sysl: "100" },
          { dysl: "66.6", mc: "用药量", sysl: "100" },
          { dysl: "107.4 ", mc: "单产", sysl: "100" },
          { dysl: "107", mc: "地力提升", sysl: "100" },
          { dysl: "107", mc: "总产量", sysl: "100" },
        ],
      },
    };
  },
  mounted() {
    this.loadEchartsAnimate();
  },
  methods: {
    chartsRelativeSize(percent, derection) {
      var windowW = this.$refs.docement.offsetWidth;
      var windowH = this.$refs.docement.offsetHeight;
      var r = 0;
      if ("h" === derection) {
        r = (percent * windowH) / 100;
      } else {
        r = (percent * windowW) / 100;
      }
      return r;
    },
    loadEchartsAnimate() {
      var that = this;
      var echarts = require("echarts");
      var myCharts = echarts.init(document.getElementById("EchartsGG"));
      var option = {
        color: ["#407FFF", "#ECFF6D"],
        tooltip: {
          trigger: "axis",
          textStyle: {
            color: "#000",
            fontSize: "36",
          },
          //   formatter: function (params) {
          //       var arr = [];
          //       params.forEach(function (item) {
          //           var N=item.seriesName;
          //           var V = '';
          //           if(item.value>100000000){//亿
          //               V += (item.value/100000000).toFixed(1) + '亿';
          //           }else if( item.value>10000){//万
          //               V += (item.value/10000).toFixed(1) + '万';
          //           }else{
          //               V += item.value;
          //           }
          //           var a = {name:N,value:V};
          //           arr.push(a);
          //       });
          //       var num = '';
          //       arr.forEach(function (item) {
          //           num += item.name+":"+item.value+"<br/>";
          //       });
          //       return params[0].name +"<br>"+ num;
          //   }
        },
        grid: {
          left: "2%",
          right: "2%",
          bottom: "15%",
          top: "15%",
          containLabel: true,
        },
        legend: {
          orient: "horizontal",
          top: "10px",
          right: "0",
          itemWidth: 9,
          itemHeight: 9,
          icon: "rect",
          textStyle: {
            color: "#fff",
            fontSize: "14",
            padding: [5, 0, 0, 0],
          },
          data: ["项目建设前", "项目建设后"],
          z: 10001,
        },
        xAxis: [
          {
            type: "category",
            axisLine: {
              lineStyle: {
                type: "solid",
                color: "#1F4457", //左边线的颜色
                width: "1", //坐标线的宽度
              },
            },
            axisLabel: {
              textStyle: {
                color: "#fff", //坐标值得具体的颜色,
                fontSize: "14",
              },
              interval: 0,
            },
            axisTick: false,
            data: [],
          },
        ],
        yAxis: [
          {
            type: "value",
            axisLine: {
              show: false,
              lineStyle: {
                type: "solid",
                color: "#20465A", //左边线的颜色
                width: "2", //坐标线的宽度
              },
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: "#e6e6e6", //坐标值得具体的颜色,
                fontSize: "14",
              },
            },
            axisTick: false,
            splitLine: {
              //坐标轴在grid区域中的分隔线（网格中的横线）
              show: true,
              lineStyle: {
                color: "#1A2F3A",
                width: 1,
                type: "solid",
              },
            },
          },
        ],
        series: [
          {
            name: "项目建设前",
            type: "bar",
            barGap: 0.5,

            barWidth: 14,
            data: [],
            itemStyle: {
              normal: {
                // //这里设置柱形图圆角 [左上角，右上角，右下角，左下角]
                barBorderRadius:[3, 3, 3, 3],
                // borderColor: "#1BC85E",
                color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                  { offset: 0, color: "#051018" },
                  { offset: 1, color: "#0DA087" },
                ]),
              },
            },
          },
          {
            name: "项目建设后",
            type: "bar",
            barGap: 0.5,
            barWidth: 14,
            data: [],
            itemStyle: {
              normal: {
                //这里设置柱形图圆角 [左上角，右上角，右下角，左下角]
                barBorderRadius:[3, 3, 3, 3],
                // borderColor: "#00A0E9",
                color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                  { offset: 0, color: "#051018" },
                  { offset: 1, color: "#066387" },
                ]),
              },
            },
          },
        ],
      };
      for (var i = 0; i < this.echartsData.list.length; i++) {
        option.xAxis[0].data.push(that.echartsData.list[i].mc);
        option.series[0].data.push(that.echartsData.list[i].sysl);
        option.series[1].data.push(that.echartsData.list[i].dysl);
      }
      myCharts.setOption(option);
    },
  },
};
</script>
<style lang="less">
.min-body {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: #010827;
}
</style>
